import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import LandingPage from "@/components/LandingPage";
import AboutPage from "@/pages/AboutPage";
import ServicePage from "@/pages/ServicePage";
import ContactPage from "@/pages/ContactPage";
import CorporateGiftingPublicPage from "@/pages/CorporateGiftingPublicPage";
import GiftingCategoryItemsPage from "@/pages/GiftingCategoryItemsPage";
import GiftingItemDetailPage from "@/pages/GiftingItemDetailPage";
import LoginPage from "@/pages/LoginPage";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminLayout from "@/components/AdminLayout";
import DashboardPage from "@/pages/DashboardPage";
import StaffPage from "@/pages/StaffPage";
import CustomersPage from "@/pages/CustomersPage";
import LeadsPage from "@/pages/LeadsPage";
import LeadDetailPage from "@/pages/LeadDetailPage";
import OrdersPage from "@/pages/OrdersPage";
import OrderDetailPage from "@/pages/OrderDetailPage";
import ReportsPage from "@/pages/ReportsPage";
import GiftingCategoriesPage from "@/pages/GiftingCategoriesPage";
import ColorsPage from "@/pages/ColorsPage";
import CorporateGiftingItemsPage from "@/pages/CorporateGiftingItemsPage";
import CategoriesPage from "@/pages/CategoriesPage";
import CategoryDetailPage from "@/pages/CategoryDetailPage";
import CategoryPublicPage from "@/pages/CategoryPublicPage";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services/:slug" element={<ServicePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/categories/:categoryId" element={<CategoryPublicPage />} />
            <Route path="/corporate-gifting" element={<CorporateGiftingPublicPage />} />
            <Route path="/corporate-gifting/:categoryId" element={<GiftingCategoryItemsPage />} />
            <Route path="/corporate-gifting/item/:itemId" element={<GiftingItemDetailPage />} />
            <Route path="/admin/login" element={<LoginPage />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<DashboardPage />} />
              <Route path="staff" element={<StaffPage />} />
              <Route path="customers" element={<CustomersPage />} />
              <Route path="leads" element={<LeadsPage />} />
              <Route path="leads/:leadId" element={<LeadDetailPage />} />
              <Route path="orders" element={<OrdersPage />} />
              <Route path="orders/:orderId" element={<OrderDetailPage />} />
              <Route path="reports" element={<ReportsPage />} />
              <Route path="master/gifting-categories" element={<GiftingCategoriesPage />} />
              <Route path="master/colors" element={<ColorsPage />} />
              <Route path="master/categories" element={<CategoriesPage />} />
              <Route path="master/categories/:categoryId" element={<CategoryDetailPage />} />
              <Route path="corporate-gifting" element={<CorporateGiftingItemsPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
